import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Grid, Box, Typography, TextField, Button, CircularProgress, Card, Modal, Chip } from '@mui/material';
import { Autocomplete } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import PromoAddMessage from './PromoAddMessage';
import PromoEditMessage from './PromoEditMessage';
import PromoDateMessage from './PromoDateMessage';
import PromoDateMessageCustomer from './PromoDateMessageCustomer';
import DeleteIcon from '@mui/icons-material/Delete';
import LeadService from '../../core/services/leadsService';
import toast from 'react-hot-toast';
import LinearProgress from '@mui/material/LinearProgress';
import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';
import { debounce, throttle } from 'lodash';
import { GlobalStyles } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import LogoutExpiredModal from '../../components/LogoutExpiredModal';
import '../../App.css'
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '22px',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    width: '558px',
    height: 'auto',
    overflow: 'auto',
};
const PromoMessage = () => {
    const [openDialog, setOpenDialog] = useState(false);
    const [promptsMessage, setPromptsMessage] = useState([]);
    const [PromptsType, setPromptsType] = useState('');
    const [userType, setUserType] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [openTimeMessage, setOpenTimeMessage] = useState(false);
    const [openTimeMessageCustomer, setOpenTimeMessageCustomer] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [deletedId, setDeletedId] = useState(null);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [sentStatus, setSentStatus] = useState('');
    const [timeMorningEvening, setTimeMorningEvening] = useState(null);
    const [timeMorningEveningCustomer, setTimeMorningEveningCustomer] = useState(null);
    const [isMorningDisabled, setIsMorningDisabled] = useState(false);
    const [isEveningDisabled, setIsEveningDisabled] = useState(false);
    const [isMorningDisabledCustomer, setIsMorningDisabledCustomer] = useState(false);
    const [isEveningDisabledCustomer, setIsEveningDisabledCustomer] = useState(false);
    const [logOutModal, setLogOutModal] = React.useState(false);

    const abortControllerRef = useRef(null);
    const theme = useTheme();
    // agent
    const handleMorningButtonClick = () => {
        setIsMorningDisabled(true);
        setIsEveningDisabled(false);
        handleOpenTimeMessage();
    };
    const handleEveningButtonClick = () => {
        setIsEveningDisabled(true);
        setIsMorningDisabled(false);
        handleOpenTimeMessage();

    };
    const handleOpenTimeMessage = () => {
        setOpenTimeMessage(true);
    };

    // customer
    const handleMorningButtonClickCustomer = () => {
        setIsMorningDisabledCustomer(true);
        setIsEveningDisabledCustomer(false);
        handleOpenTimeMessageCustomer();
    };
    const handleEveningButtonClickCustomer = () => {
        setIsEveningDisabledCustomer(true);
        setIsMorningDisabledCustomer(false);
        handleOpenTimeMessageCustomer();

    };
    const handleOpenTimeMessageCustomer = () => {
        setOpenTimeMessageCustomer(true);
    };
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();
        return `${day}-${month}-${year}`;
    };

    const adjustTimeBasedOnOffsetForReceivedData = (dateString, offsetInHours) => {
        const date = new Date(dateString);
        // Convert to UTC and then apply offset
        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
        utcDate.setHours(utcDate.getHours() + offsetInHours);
        return utcDate;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };

    const formatDateTime = (date) => {
        const options = { year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
        return date.toLocaleDateString(undefined, options).replace(',', '');
    };
    const userOffset = getUserOffset();
    const handleClickOpen = (id) => {
        setOpenDialog(true);
        setDeletedId(id);
    };
    const handleClickClose = () => {
        setOpenDialog(false);
    };

    const options = [
        { label: 'Motivational', value: 'motivational' },
        { label: 'Feature', value: 'feature' },
    ];

    const optionsUser = [
        { label: 'Agent', value: 'agent' },
        { label: 'Customer', value: 'customer' },
    ];

    const statusOptions = [
        { label: 'Sent', value: 'sent' },
        { label: 'Initiated', value: 'initiated' },
        { label: 'Scheduled', value: 'scheduled' },
        { label: 'Pending', value: 'pending' },
    ];

    const GetAllPrompts = async (currentPage, PromptsType = '', sentStatus = '', userType = '', signal) => {
        try {
            setIsLoading(true);
            const res = await LeadService.AllPrompts(currentPage, PromptsType, sentStatus, userType, signal);
            if (res.data.success) {
                setPromptsMessage(res?.data?.data?.data);
                setCurrentPage(res?.data?.data?.current_page || 1);
                setTotalPages(Math.ceil((res?.data?.data?.total || 0) / (res?.data?.data?.per_page || 1)));
            }
        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } finally {
            setIsLoading(false);
        }
    };

    const throttledGetAllPrompts = useCallback(
        throttle((currentPage, PromptsType, sentStatus, userType, signal) => {
            GetAllPrompts(currentPage, PromptsType, sentStatus, userType, signal);
        }, 2000),
        []
    );

    const fetchGetAllPrompts = useCallback(
        debounce((currentPage, PromptsType, sentStatus, userType) => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            throttledGetAllPrompts(currentPage, PromptsType, sentStatus, userType, abortController.signal);
        }, 300),
        [throttledGetAllPrompts]
    );
    useEffect(() => {
        fetchGetAllPrompts(currentPage, PromptsType, sentStatus, userType);
    }, [currentPage, PromptsType, sentStatus, userType, fetchGetAllPrompts]);

    const handlePromptMessageDeleted = async () => {
        try {
            setDeleteLoading(true);
            const res = await LeadService.DeletePromptNotification(deletedId);
            if (res?.data?.success) {
                toast.success(res?.data?.message);
                GetAllPrompts();
                setOpenDialog(false);
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setDeleteLoading(false);
        }
    };
    // for agent
    const getMessageTime = async () => {
        try {
            const res = await LeadService.getPromptMessageSendTimes();
            if (res?.data?.success) {
                setTimeMorningEvening(res?.data?.data);
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    useEffect(() => {
        getMessageTime();
    }, []);

    // for Customer

    const getMessageTimeCustomer = async () => {
        try {
            const res = await LeadService.getCustomerPromptMessageSendTimes();
            if (res?.data?.success) {
                setTimeMorningEveningCustomer(res?.data?.data);
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    useEffect(() => {
        getMessageTimeCustomer();
    }, []);

    const HandleChangePromptsType = (event, newValue) => {
        setPromptsType(newValue?.value);
    };

    const HandleChangeUserType = (event, newValue) => {
        setUserType(newValue?.value);
    };

    const HandleChangeStatusType = (event, newValue) => {
        setSentStatus(newValue?.value);
    };
    const handleClickEdit = (id) => {
        setSelectedId(id);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedId(null); // reset selectedId when modal is closeda
    };
    const getStatusColor = (status) => {
        switch (status) {
            case 'pending':
                return '#6db5cc'; // Light Blue
            case 'sent':
                return '#54d754'; // Light Green
            case 'initiated':
                return '#facb0d'; // Light Orange
            case 'scheduled':
                return '#ab9797'; // Grey
            default:
                return '#a8a0a0';
        }
    };
    const capitalizeFirstLetter = (string) => {
        if (!string) return '';
        return string.charAt(0).toUpperCase() + string.slice(1);
    };
    return (
        <>
            <ThemeProvider theme={theme}>
                <GlobalStyles
                    styles={{
                        '::-webkit-scrollbar': {
                            width: '14px', // Set the desired width for the scrollbar
                        },
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                            borderRadius: '10px', // Set the border radius for a rounded effect
                        },
                    }}
                />
                <Box>
                    <div style={{ marginBottom: '15px' }}> {isLoading && <LinearProgress />}</div>
                    <Box>
                                            <Typography className="services-animated-text">
                                                Promo Message
                                            </Typography>
                                        </Box>
                    <Box style={{ display: 'flex', justifyContent: 'end' }}>
                        <div style={{ display: 'flex', gap: '10px', marginBottom: '10px', flexWrap: 'wrap', justifyContent: 'end' }}>
                            {(!userType || userType === "agent") && (
                                <PromoDateMessage
                                    GetAllPrompts={GetAllPrompts}
                                    getMessageTime={getMessageTime}
                                    open={openTimeMessage}
                                    setOpen={setOpenTimeMessage}
                                    afternoon_Time={timeMorningEvening?.afternoon_push_time}
                                    morning_Time={timeMorningEvening?.morning_push_time}
                                    agentID={timeMorningEvening?.id}
                                    isMorningDisabled={isMorningDisabled}
                                    isEveningDisabled={isEveningDisabled}
                                    setIsMorningDisabled={setIsMorningDisabled}
                                    setIsEveningDisabled={setIsEveningDisabled}
                                />
                            )}
                            {(!userType || userType === "customer") && (
                                <PromoDateMessageCustomer
                                    GetAllPrompts={GetAllPrompts}
                                    getMessageTimeCustomer={getMessageTimeCustomer}
                                    open={openTimeMessageCustomer}
                                    setOpen={setOpenTimeMessageCustomer}
                                    afternoon_Time={timeMorningEveningCustomer?.afternoon_push_time}
                                    morning_Time={timeMorningEveningCustomer?.morning_push_time}
                                    CustomerID={timeMorningEveningCustomer?.id}
                                    isMorningDisabledCustomer={isMorningDisabledCustomer}
                                    isEveningDisabledCustomer={isEveningDisabledCustomer}
                                    setIsMorningDisabledCustomer={setIsMorningDisabledCustomer}
                                    setIsEveningDisabledCustomer={setIsEveningDisabledCustomer}
                                />
                            )}
                            <PromoAddMessage GetAllPrompts={GetAllPrompts} />
                            <Autocomplete
                                options={options}
                                getOptionLabel={(option) => option.label}
                                renderInput={(params) => <TextField {...params} label="Prompts Type" />}
                                value={options.find((option) => option.value === PromptsType) || null}
                                onChange={HandleChangePromptsType}
                                sx={{
                                    width: {
                                        xs: "150px",
                                        sm: "200px",
                                        md: "250px"
                                    }, '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                    },
                                }}
                            />
                            <Autocomplete
                                options={optionsUser}
                                getOptionLabel={(optionsUser) => optionsUser.label}
                                renderInput={(params) => <TextField {...params} label="User Type" />}
                                value={optionsUser.find((optionsUser) => optionsUser.value === userType) || null}
                                onChange={HandleChangeUserType}
                                sx={{
                                    width: {
                                        xs: "150px",
                                        sm: "200px",
                                        md: "250px"
                                    }, '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                    },
                                }}
                            />
                            <Autocomplete
                                options={statusOptions}
                                getOptionLabel={(statusOptions) => statusOptions.label}
                                renderInput={(params) => <TextField {...params} label="Status Type" />}
                                value={statusOptions.find((option) => option.value === sentStatus) || null}
                                onChange={HandleChangeStatusType}
                                sx={{
                                    width: {
                                        xs: "150px",
                                        sm: "200px",
                                        md: "250px"
                                    }, '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                    },
                                }}
                            />
                        </div>
                    </Box>
                    {/* agent */}
                    {(!userType || userType === "agent") && (
                        <Box style={{ display: 'flex', justifyContent: 'flex-start', gap: '12px', marginBottom: '12px', marginTop: '12px' }}>

                            {timeMorningEvening?.morning_push_time ? (
                                <>
                                    <Chip label="Agent: " sx={{ fontWeight: 'bold', fontSize: '18px', color: 'black', marginTop: '2px' }} />
                                    <Typography style={{ fontWeight: 'bold' }}>
                                        Morning Time ={' '}
                                        <Button onClick={handleMorningButtonClick} style={{ borderRadius: '15px' }}>
                                            {' '}
                                            {new Date(`1970-01-01T${timeMorningEvening.morning_push_time}`).toLocaleTimeString([], {
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                hour12: true,
                                            })}
                                            <EditIcon style={{ fontSize: '15px', marginLeft: '5px' }} />
                                        </Button>
                                    </Typography>
                                </>

                            ) : (
                                <Typography style={{ fontWeight: 'bold' }}></Typography>
                            )}

                            {timeMorningEvening?.afternoon_push_time ? (
                                <Typography style={{ fontWeight: 'bold' }}>
                                    Evening Time ={' '}
                                    <Button onClick={handleEveningButtonClick} style={{ borderRadius: '15px' }}>
                                        {new Date(`1970-01-01T${timeMorningEvening.afternoon_push_time}`).toLocaleTimeString([], {
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: true,
                                        })}
                                        <EditIcon style={{ fontSize: '15px', marginLeft: '5px' }} />
                                    </Button>
                                </Typography>
                            ) : (
                                <Typography style={{ fontWeight: 'bold' }}></Typography>
                            )}
                        </Box>
                    )}

                    {/* customer */}
                    {(!userType || userType === "customer") && (
                        <Box Box style={{ display: 'flex', justifyContent: 'flex-start', gap: '12px', marginBottom: '12px', marginTop: '12px' }}>

                            {timeMorningEveningCustomer?.morning_push_time ? (
                                <>
                                    <Chip label="Customer: " sx={{ fontWeight: 'bold', fontSize: '18px', color: 'black', marginTop: '2px' }} />
                                    <Typography style={{ fontWeight: 'bold' }}>
                                        Morning Time ={' '}
                                        <Button onClick={handleMorningButtonClickCustomer} style={{ borderRadius: '15px' }}>
                                            {' '}
                                            {new Date(`1970-01-01T${timeMorningEveningCustomer.morning_push_time}`).toLocaleTimeString([], {
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                hour12: true,
                                            })}
                                            <EditIcon style={{ fontSize: '15px', marginLeft: '5px' }} />
                                        </Button>
                                    </Typography>
                                </>

                            ) : (
                                <Typography style={{ fontWeight: 'bold' }}></Typography>
                            )}

                            {/* {timeMorningEveningCustomer?.afternoon_push_time ? (
                                <Typography style={{ fontWeight: 'bold' }}>
                                    Evening Time ={' '}
                                    <Button onClick={handleEveningButtonClickCustomer} style={{ borderRadius: '15px' }}>
                                        {new Date(`1970-01-01T${timeMorningEveningCustomer.afternoon_push_time}`).toLocaleTimeString([], {
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: true,
                                        })}
                                        <EditIcon style={{ fontSize: '15px', marginLeft: '5px' }} />
                                    </Button>
                                </Typography>
                            ) : (
                                <Typography style={{ fontWeight: 'bold' }}></Typography>
                            )} */}
                        </Box>
                    )}

                    <Box>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                            {promptsMessage && promptsMessage?.length > 0 ? (
                                promptsMessage.map((message, index) => {
                                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(message?.created_at, userOffset);
                                    const adjustedDateSend = adjustTimeBasedOnOffsetForReceivedData(message?.updated_at, userOffset);
                                    const formattedDate = adjustedDate ? formatDateTime(adjustedDate) : 'No date available';
                                    const formattedDateSend = adjustedDateSend ? formatDateTime(adjustedDateSend) : 'No date available';
                                    // Alternate background color based on index
                                    const backgroundColor = index % 2 === 0 ? '#f5f5f5' : '#ffffff';
                                    return (
                                        <>
                                            <Card
                                                key={message.id}
                                                style={{
                                                    px: 1,
                                                    py: 0.1,
                                                    mb: 1,
                                                    borderRadius: '22px',
                                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                    padding: '20px',
                                                    backgroundColor: backgroundColor, // Apply alternating background color
                                                    cursor: 'pointer', // Add hover cursor
                                                }}
                                                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#e0e0e0')} // Hover effect
                                                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = backgroundColor)} // Restore original color
                                            >
                                                <Grid container>
                                                    <Grid item xs={12} sm={3} md={2} lg={2}>
                                                        <Box>
                                                            <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#474444' }}>
                                                                Type: 
                                                            </span>
                                                            <span style={{ fontSize: '14px', color: '#7f7b7b' }}>
                                                                {' '}
                                                                {capitalizeFirstLetter(message?.type)}
                                                            </span>
                                                        </Box>
                                                    </Grid>


                                                    <Grid item xs={12} sm={3} md={2} lg={2}>
                                                        <Box>
                                                            <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#474444' }}>
                                                                Status:  
                                                            </span>
                                                            <span
                                                                style={{ fontSize: '14px', fontWeight: 'bold', color: getStatusColor(message?.status) }}
                                                            >
                                                                {capitalizeFirstLetter(message?.status)}
                                                                {message?.status === 'scheduled' && (
                                                                    <>
                                                                        {message.type === 'feature' && ' for tomorrow evening at'}
                                                                        {message.type === 'motivational' && ' for tomorrow morning at'}{' '}
                                                                        {new Date(`1970-01-01T${message?.time}`).toLocaleTimeString([], {
                                                                            hour: '2-digit',
                                                                            minute: '2-digit',
                                                                            hour12: true,
                                                                        })}
                                                                    </>
                                                                )}
                                                                 {message?.status === 'initiated' && ' other time zone'}
                                                            </span>
                                                        </Box>
                                                    </Grid>

                                                    <Grid item xs={12} sm={3} md={4} lg={4}>
                                                        <Box>
                                                            <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#474444' }}>
                                                                Created At: 
                                                            </span>
                                                            <span style={{ fontSize: '14px', color: '#7f7b7b' }}> {formattedDate}</span>
                                                        </Box>
                                                    </Grid>

                                                    <Grid item xs={12} sm={3} md={4} lg={4}>
                                                        <Box>
                                                            {message?.status === 'pending' && (
                                                                <>
                                                                    <Button
                                                                        onClick={() => handleClickEdit(message?.id)}
                                                                        size="small"
                                                                        color="primary"
                                                                        style={{
                                                                            borderRadius: '12px',
                                                                            textTransform: 'capitalize',
                                                                            fontSize: '18px',
                                                                            height: '30px',
                                                                        }}
                                                                        sx={{ fontFamily: 'inherit', }}
                                                                        startIcon={<EditIcon />}
                                                                        variant="outlined"
                                                                    >
                                                                        Edit
                                                                    </Button>
                                                                    <Button
                                                                        onClick={() => handleClickOpen(message?.id)}
                                                                        size="small"
                                                                        color="error"
                                                                        style={{
                                                                            borderRadius: '12px',
                                                                            textTransform: 'capitalize',
                                                                            fontSize: '18px',
                                                                            height: '30px',
                                                                        }}
                                                                        sx={{ fontFamily: 'inherit', }}
                                                                        startIcon={<DeleteIcon />}
                                                                        variant="outlined"
                                                                    >
                                                                        Delete
                                                                    </Button>
                                                                </>
                                                            )}

                                                            {message?.status === 'scheduled' && (
                                                                <Button
                                                                    onClick={() => handleClickEdit(message?.id)}
                                                                    size="small"
                                                                    color="primary"
                                                                    style={{
                                                                        borderRadius: '12px',
                                                                        textTransform: 'capitalize',
                                                                        fontSize: '18px',
                                                                        height: '30px',
                                                                    }}
                                                                    startIcon={<EditIcon />}
                                                                    variant="outlined"
                                                                >
                                                                    Edit
                                                                </Button>
                                                            )}

                                                            {message?.status === 'sent' && (
                                                                <Box>
                                                                    <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#474444' }}>
                                                                        Sent At: 
                                                                    </span>
                                                                    <span style={{ fontSize: '14px', color: '#7f7b7b',paddingLeft: '4px' }}>
                                                                         {formattedDateSend}
                                                                    </span>
                                                                </Box>
                                                            )}
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={3} md={12} lg={12}>
                                                        <Box>
                                                            <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#474444' }}>
                                                                User:
                                                            </span>
                                                            <span style={{ fontSize: '14px', color: '#7f7b7b' }}>
                                                                {' '}
                                                                {capitalizeFirstLetter(message?.notification_for)}
                                                            </span>
                                                        </Box>
                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                                        <Box>
                                                            <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#474444' }}>
                                                                Message: 
                                                            </span>
                                                            <span style={{ fontSize: '14px', color: '#7f7b7b' }}> {message?.message}</span>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Card>
                                        </>
                                    );
                                })
                            ) : (
                                <Card style={{ padding: '20px', borderRadius: '10px', marginBottom: '12px' }}>
                                    <Typography style={{ fontSize: '18px', color: '#858585' }}>No data found</Typography>
                                </Card>
                            )}
                        </div>
                        <div>
                            <Pagination
                                count={totalPages}
                                color="primary"
                                page={currentPage}
                                onChange={(event, value) => setCurrentPage(value)}
                                style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}
                            />
                        </div>
                    </Box>

                    <Modal open={openDialog} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <Box sx={style}>
                            <div style={{ marginTop: '20px', position: 'relative' }}>
                                <Box
                                    sx={{
                                        display: 'grid',
                                        padding: '10px',
                                        gap: '10px',
                                    }}
                                >
                                    <Box style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                                        <Box>
                                            <CancelIcon style={{ fontSize: '34px' }} />
                                        </Box>
                                        <Box style={{ display: 'grid', gap: '10px' }}>
                                            <div>
                                                <span style={{ fontSize: '20px', fontWeight: 'bold' }}>
                                                    Are you sure you want to delete this Prompt Message?
                                                </span>
                                            </div>
                                            <div>
                                                <span style={{ fontSize: '16px', color: '#252F46' }}>
                                                    This action will delete this message permanently, and you can not undo this.
                                                </span>
                                            </div>
                                        </Box>
                                    </Box>
                                </Box>

                                <Box style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                    <Button
                                        onClick={handleClickClose}
                                        style={{
                                            width: '140px',
                                            height: '43px',
                                            backgroundColor: 'white',
                                            fontWeight: '500',
                                            borderRadius: '4px',
                                            border: ' 1px solid #587DBF',
                                            color: '#252F46',
                                            fontSize: '15px',
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        onClick={handlePromptMessageDeleted}
                                        style={{
                                            width: '140px',
                                            height: '43px',
                                            backgroundColor: '#5379BD',
                                            fontWeight: '500',
                                            borderRadius: '4px',
                                            border: ' 1px solid #587DBF',
                                            color: 'white',
                                            fontSize: '15px',
                                        }}
                                        disabled={deleteLoading}
                                    >
                                        {deleteLoading ? 'Deleting...' : 'Delete'}
                                        {deleteLoading && (<CircularProgress sx={{ visibility: deleteLoading ? '' : 'hidden' }} />)}
                                    </Button>

                                </Box>
                            </div>
                        </Box>
                    </Modal>
                </Box>
            </ThemeProvider >
            <PromoEditMessage open={open} setOpen={setOpen} selectedId={selectedId} GetAllPrompts={GetAllPrompts} />
            <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal} />
        </>
    );
};
export default PromoMessage;
